import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ProtectedRoute } from "./utils";
import LoginLayout from "./layout/LoginLayout/LoginLayout";
import { Toaster } from "react-hot-toast";
import { ConfigProvider } from "antd";
import HomePageDummy from "./layout/HomePageDummy/HomePageDummy";
import { lazy, Suspense } from "react";
import { Spin } from "antd";

// Lazy load all layout components
const OtcMainLayout = lazy(() => import("./layout/OtcMainLayout/OtcMainLayout"));
const ComplianceLayout = lazy(() => import("./layout/ComplianceLayout/ComplianceLayout"));
const FiuLayout = lazy(() => import("./layout/FiuLayout/FiuLayout"));
const InternalTeamLayout = lazy(() => import("./layout/InternalTeamLayout/InternalTeamLayout"));
const AccountingLayout = lazy(() => import("./layout/AccountingLayout/AccountingLayout"));
const ExternalAccountingLayout = lazy(() => import("./layout/ExternalAccountingLayout/ExternalAccountingLayout"));
const TaasLayout = lazy(() => import("./layout/TaasLayout/TaasLayout"));
const TransactionLayout = lazy(() => import("./layout/TransactionLayout/TransactionLayout"));
const ApiDashboardLayout = lazy(() => import("./layout/ApiDashboardLayout/ApiDashboardLayout"));
const KybOnboardingLayout = lazy(() => import("./layout/KybOnboardingLayout/index.jsx"));
const NonIndianOnboardingLayout = lazy(() => import("./layout/NonIndianOnboardingLayout/index.jsx"));
const OtcNonIndiaLayout = lazy(() => import("./layout/OtcNonIndiaLayout/index.jsx"));
const IpLogsLayout = lazy(() => import("./layout/IpLogsLayout/Index.jsx"));
const LedgerLayout = lazy(() => import("./layout/LedgerLayout/index.jsx"));
const EddDashboardLayout = lazy(() => import("./layout/EddDashboardLayout/EddDashboardLayout"));
const KycReviewLayout = lazy(() => import("./layout/KycReviewLayout/KycReviewLayout.jsx"));

// Loading fallback component
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '100vh' 
  }}>
    <Spin size="large" tip="Loading..." />
  </div>
);

// Protected Route wrapper with Suspense
const LazyProtectedRoute = ({ children }) => (
  <ProtectedRoute>
    <Suspense fallback={<LoadingFallback />}>
      {children}
    </Suspense>
  </ProtectedRoute>
);

// Route configuration with metadata
const routeConfig = [
  {
    path: "/",
    element: <HomePageDummy />,
    isProtected: false,
  },
  // Login routes
  {
    path: "/fiu-login",
    element: <LoginLayout navigateTo="fiu" />,
    isProtected: false,
  },
  {
    path: "/admin-2fa/login",
    element: <LoginLayout navigateTo="admin-2fa" />,
    isProtected: false,
  },
  {
    path: "/compliance-login", 
    element: <LoginLayout navigateTo="compliance" />,
    isProtected: false,
  },
  {
    path: "/internal-login",
    element: <LoginLayout navigateTo="internal" />,
    isProtected: false,
  },
  {
    path: "/accounting-login",
    element: <LoginLayout navigateTo="accounting" />,
    isProtected: false,
  },
  {
    path: "/otc-login",
    element: <LoginLayout navigateTo="otc" />,
    isProtected: false,
  },
  {
    path: "/external-accounting-login",
    element: <LoginLayout navigateTo="external-accounting" />,
    isProtected: false,
  },
  {
    path: "/taas-login",
    element: <LoginLayout navigateTo="taas" />,
    isProtected: false,
  },
  {
    path: "/transaction-login",
    element: <LoginLayout navigateTo="transaction" />,
    isProtected: false,
  },
  {
    path : "/kybOnboarding-login",
    element: <LoginLayout navigateTo="kybOnboarding" />,
    isProtected: false,
  },
  {
    path: "/nonIndianKyb-login",
    element: <LoginLayout navigateTo="nonIndianKyb" />,
    isProtected: false,
  },
  {
    path: "/otcNonIndia-login",
    element: <LoginLayout navigateTo="otcNonIndia" />,
    isProtected: false,
  },
  {
    path: "/apiDashboard-login",
    element: <LoginLayout navigateTo="apiDashboard" />,
    isProtected: false,
  },
  {
    path: "/iplogs-login",
    element: <LoginLayout navigateTo="iplogs" />,
    isProtected: false,
  },
  {
    path: "/ledger-login",
    element: <LoginLayout navigateTo="ledger" />,
    isProtected: false,
  },
  {
    path: "/edd-login",
    element: <LoginLayout navigateTo="edd" />,
    isProtected: false,
  },
  {
    path: "/kycreview-login",
    element: <LoginLayout navigateTo="kyc_review" />,
    isProtected: false,
  },
  
 // Protected routes with lazy loading
  {
    path: "/internal",
    component: InternalTeamLayout,
    isProtected: true,
  },
  {
    path: "/otc",
    component: OtcMainLayout,
    isProtected: true,
  },
  {
    path: "/compliance",
    component: ComplianceLayout,
    isProtected: true,
  },
  {
    path: "/admin-2fa",
    component: lazy(() => import("./layout/Admin2FaLayout/Admin2FaSecurity")),
    isProtected: true,
  },
  {
    path: "/fiu",
    component: FiuLayout,
    isProtected: true,
  },
  {
    path: "/accounting",
    component: AccountingLayout,
    isProtected: true,
  },
  {
    path: "/external-accounting",
    component: ExternalAccountingLayout,
    isProtected: true,
  },
  {
    path: "/taas",
    component: TaasLayout,
    isProtected: true,
  },
  {
    path: "/transaction",
    component: TransactionLayout,
    isProtected: true,
  },
  {
    path: "/kybOnboarding",
    component: KybOnboardingLayout,
    isProtected: true,
  },
  {
    path: "/nonIndianKyb",
    component: NonIndianOnboardingLayout,
    isProtected: true,
  },
  {
    path: "/otcNonIndia",
    component: OtcNonIndiaLayout,
    isProtected: true,
  },
  {
    path: "/apiDashboard",
    component: ApiDashboardLayout,
    isProtected: true,
  },
  {
    path: "/iplogs",
    component: IpLogsLayout,
  },
  {
    path: "/edd",
    component : EddDashboardLayout,
    isProtected: true,
  },
  {
    path: "/transaction",
    component : TransactionLayout,
    isProtected: true,
  },
  {
    path: "/ledger",
    component: LedgerLayout,
    isProtected: true,
  },
  {
    path : "/kyc_review",
    component : KycReviewLayout,
    isProtected: true,
  }
];

function App() {
  // Dynamic route generation
  const generateRoutes = () => {
    return routeConfig.map((route) => {
      const { path, element, component, isProtected } = route;
      
      if (element) {
        // Static routes (login routes, home)
        return { path, element };
      }
      
      if (component) {
        // Dynamic routes with lazy loading
        const Component = component;
        return {
          path,
          element: isProtected ? (
            <LazyProtectedRoute>
              <Component />
            </LazyProtectedRoute>
          ) : (
            <Suspense fallback={<LoadingFallback />}>
              <Component />
            </Suspense>
          ),
        };
      }
      
      return route;
    });
  };

  const router = createBrowserRouter(generateRoutes());

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#543696",
          },
        }}
      >
        <RouterProvider router={router} />
      </ConfigProvider>
      <Toaster
        position="top-right"
        reverseOrder={false}
        containerStyle={{
          top: 80,
        }}
      />
    </>
  );
}

export default App;
